import posthog from 'posthog-js';
import { POSTHOG_HOST, POSTHOG_PUBLIC_KEY } from '~/assets/constants';
import { isDev } from '~/helpers/environment';

export default defineNuxtPlugin(nuxtApp => {
  const posthogClient = posthog.init(POSTHOG_PUBLIC_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
    capture_pageview: false, // we add manual pageview capturing below,
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: false,
      maskCapturedNetworkRequestFn(req) {
        // entirely replaces PostHog's automatic payload redaction.
        return req;
      }
    },
    loaded(posthog) {
      if (isDev()) posthog.debug(false);
    }
  });

  // Make sure that pageviews are captured with each route change
  const router = useRouter();
  router.afterEach((to, from) => {
    nextTick(() => {
      if (from.fullPath != to.fullPath) {
        posthog.capture('$pageleave', {
          current_url: from.fullPath,
        });
      }

      posthog.capture('$pageview', {
        current_url: to.fullPath
      });
    });
  });

  nuxtApp.hook('vue:error', error => {
    posthogClient.captureException(error);
  });

  return {
    provide: {
      posthog: posthogClient
    }
  };
});